<template>
  <div id="stakeholdersMain">
    <div
      v-if="role_type === 'coach'"
      class="mainCard"
    >
      <el-page-header
        title="Go Back"
        :content="null"
        @back="$router.go(-1)"
      />
    </div>

    <!-- Top card -->
    <stakeholdersTop
      class="stakeholdersTop"
      :add-dialog.sync="addDialog"
    />

    <!-- Desktop table -->
    <div v-if="['desktop', 'laptop'].includes($mq)">
      <stakeholdersList
        :loading="loading"
        :stakeholders="stakeholders"
        :edit-dialog.sync="editDialog"
        :is-confirmed="isConfirmed"
        :session="formattedSessionStatus"
        @confirmStakeholders="confirmStakeholders"
      />
    </div>

    <!-- Mobile table -->
    <div v-else>
      <stakeholdersMobile
        ref="mobileComponent"
        v-loading="loading"
        :stakeholders.sync="stakeholders"
        :edit-dialog.sync="editDialog"
        :is-confirmed.sync="isConfirmed"
        :session="formattedSessionStatus"
        @confirmStakeholders="confirmStakeholders"
        @reload="getStakeholders"
      />
    </div>

    <StakeholderEditModal
      :show.sync="editDialog.flag"
      :edit-dialog.sync="editDialog"
      :is-confirmed="isConfirmed"
      @closeSwipe="closeAll"
      @reload="getStakeholders"
    />

    <StakeholderManageModal
      :show.sync="addDialog"
      :main-stakeholders.sync="stakeholders"
      :session="formattedSessionStatus"
      @reload="getStakeholders"
    />

    <PublishModal
      v-if="publishDialog"
      :show.sync="publishDialog"
      :published.sync="isConfirmed"
    />
  </div>
</template>

<script>
import api from '@/api';
import { mapState } from 'vuex';
import stakeholdersTop from './StakeholdersTop.vue';
import stakeholdersList from './StakeholdersList.vue';
import stakeholdersMobile from './StakeholdersMobile.vue';
import StakeholderEditModal from './widget/StakeholdersEditModal.vue';
import StakeholderManageModal from './widget/StakeholderManageModal.vue';
import PublishModal from './widget/PublishModal.vue';

export default {
  components: {
    stakeholdersTop,
    stakeholdersList,
    stakeholdersMobile,
    StakeholderEditModal,
    StakeholderManageModal,
    PublishModal,
  },

  data() {
    return {
      addDialog: false,
      publishDialog: false,
      editDialog: {
        flag: false,
        user: null,
      },
      stakeholders: [],
      leader: null,
      isConfirmed: false,
      loading: false,
    };
  },

  computed: {
    ...mapState({
      session: (state) => state.processStatus.process.session || 0,
      role_type: (state) => state.user.user.role_type,
    }),

    formattedSessionStatus() {
      let session = 0;

      if (this.role_type === 'coach' && this.leader) {
        const tmp = this.leader.session_id.split('_');
        if (tmp.length && /^[0-9]*$/.test(tmp[(tmp.length - 1)])) {
          session = parseInt(tmp[(tmp.length - 1)], 10);
        }
      } else {
        session = this.session;
      }

      return session;
    },

    numberOfPublishStakeholder() {
      let length = 0;
      if (this.stakeholders && this.stakeholders.length) {
        length = this.stakeholders
          .filter((el) => (el.is_active && (el.org_relationship !== 'manager'))).length;
      }
      return length;
    },
  },

  created() {
    if (this.role_type === 'coach') {
      this.getLeaderDetails();
    }
    this.getStakeholders();
  },

  methods: {
    closeAll() {
      if (this.$refs.mobileComponent) { this.$refs.mobileComponent.closeAll(); }
    },

    async getStakeholders() {
      try {
        this.loading = true;
        let response;
        if (this.role_type === 'coach') {
          response = await api.getLeaderCoworker(this.$route.params.id);
        } else {
          response = await api.getStakeholders();
        }
        this.stakeholders = response.data.supporters;
        this.isConfirmed = response.data.is_supporter_confirmed;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getLeaderDetails() {
      try {
        let response = {};
        this.loading = true;
        response = await api.getCoachLeaderDetails(this.$route.params.id);
        this.leader = response.data;
      } catch (err) {
        console.log(err);
        if (err.msg) { this.$message.error(err.msg); }
      } finally {
        this.loading = false;
      }
    },

    confirmStakeholders() {
      if (this.numberOfPublishStakeholder < 3) {
        this.$alert(this.$t('leader.coworker.minimumRequired'), {
          confirmButtonText: this.$t('common.close'),
        });
      } else {
        this.publishDialog = true;
      }
    },
  },
};
</script>

<style lang="scss">
#stakeholdersMain {
  .stakeholdersTop {
    margin-bottom: 15px;
  }
}
</style>
